interface ShouldNoIndexInput {
  appEnv: string | undefined;
  isPreview: boolean | undefined;
  comContentNoIndex: boolean | undefined;
}

export const shouldNoIndex = ({ appEnv, isPreview, comContentNoIndex }: ShouldNoIndexInput): boolean => {
  if (appEnv !== 'production') return true;
  if (isPreview === true) return true;
  if (comContentNoIndex === true) return true;
  return false;
};
